import _JSXStyle from "styled-jsx/style";
import { jsx as _jsx } from "react/jsx-runtime";
export function getFocusStyles(theme) {
  return {
    styles: /*#__PURE__*/_jsx(_JSXStyle, {
      id: "1994080046",
      dynamic: [theme.type === 'dark' ? theme.palette.accents_2 : theme.palette.background, theme.palette.primary],
      children: `.__jsx-style-dynamic-selector:focus:not(:focus-visible){box-shadow:none;}.__jsx-style-dynamic-selector:focus{outline:none;box-shadow:0 0 0 2px ${theme.type === 'dark' ? theme.palette.accents_2 : theme.palette.background}, 0 0 0 4px ${theme.palette.primary};}`
    }),
    className: _JSXStyle.dynamic([["1994080046", [theme.type === 'dark' ? theme.palette.accents_2 : theme.palette.background, theme.palette.primary]]])
  };
}